import { render, staticRenderFns } from "./PersonTaxableRebateRegGrid.vue?vue&type=template&id=0776567c"
import script from "./PersonTaxableRebateRegGrid.vue?vue&type=script&lang=js"
export * from "./PersonTaxableRebateRegGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports